/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { identityProviderConnectionsListApplications } from "../funcs/identityProviderConnectionsListApplications.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListIdentityProviderConnectionApplicationsResult } from "../models/components/listidentityproviderconnectionapplicationsresult.js";
import {
  ListIdentityProviderConnectionApplicationsRequest,
  ListIdentityProviderConnectionApplicationsSecurity,
} from "../models/operations/listidentityproviderconnectionapplications.js";
import { unwrapAsync } from "../types/fp.js";
export type IdentityProviderConnectionApplicationsQueryData =
  ListIdentityProviderConnectionApplicationsResult;

export function prefetchIdentityProviderConnectionApplications(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListIdentityProviderConnectionApplicationsRequest,
  security?: ListIdentityProviderConnectionApplicationsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildIdentityProviderConnectionApplicationsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildIdentityProviderConnectionApplicationsQuery(
  client$: GramCore,
  request: ListIdentityProviderConnectionApplicationsRequest,
  security?: ListIdentityProviderConnectionApplicationsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<IdentityProviderConnectionApplicationsQueryData>;
} {
  return {
    queryKey: queryKeyIdentityProviderConnectionApplications({
      id: request.id,
      includeRemoved: request.includeRemoved,
      gramSession: request.gramSession,
    }),
    queryFn: async function identityProviderConnectionApplicationsQueryFn(
      ctx,
    ): Promise<IdentityProviderConnectionApplicationsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(identityProviderConnectionsListApplications(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyIdentityProviderConnectionApplications(
  parameters: {
    id: string;
    includeRemoved?: boolean | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "identityProviderConnections",
    "listApplications",
    parameters,
  ];
}
